import React, { useEffect, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import { bool, func, shape } from "prop-types";
import { Field, Form, Formik } from "formik";
import * as i18nUtils from "util/i18n";
import { selectors as afipPaymentLinkSelectors, actions as afipPaymentLinkActions } from "reducers/afipPaymentLink";
import CustomText from "pages/_components/CustomText/CustomText";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";

const FORM_ID = "vep.addTaxpayer";

const DeleteTaxpayerForm = ({ handleClose, openForm, taxpayer }) => {
    const dispatch = useDispatch();
    const formRef = useRef();

    useEffect(() => {
        if (!openForm) {
            formRef.current.resetForm();
        } else {
            formRef.current.setFieldValue("cuit", taxpayer?.cuit);
            formRef.current.setFieldValue("reference", taxpayer?.denomination);
        }
    }, [openForm]);

    const closeForm = () => {
        formRef.current.resetForm();
        handleClose();
    };

    const formikProps = {
        validateOnChange: true,
        validateOnBlur: false,
        onSubmit: (values) => {
            if (values) {
                const { cuit } = values;
                dispatch(afipPaymentLinkActions.deleteTaxpayer({ cuit }));
                closeForm();
            }
        },
    };

    return (
        <div className="container centered">
            <h1 className="title-content form-drawer-title">
                <CustomText text={i18nUtils.get("vep.deleteTaxpayer.title", "Eliminar contribuyente")} />
            </h1>
            <Formik {...formikProps} ref={formRef}>
                {() => (
                    <Form>
                        <div className="form-drawer-content">
                            <div className="pb-6" />
                            <I18n
                                id="vep.deleteTaxpayer.message"
                                defaultValue={i18nUtils.get(
                                    "vep.deleteTaxpayer.message",
                                    "Estás por eliminar el contribuyente seleccionado. ¿Querés continuar?",
                                )}
                            />
                            <div className="pb-6" />
                            <Field
                                autoComplete="off"
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="cuit"
                                labelTextDefault={i18nUtils.get("vep.addTaxpayer.cuit", "CUIT/CUIL del contribuyente")}
                                hidePlaceholder
                                disabled
                            />
                            <Field
                                autoComplete="off"
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="reference"
                                labelTextDefault={i18nUtils.get("vep.taxpayer.reference", "Referencia")}
                                hidePlaceholder
                                disabled
                            />
                            <Button type="submit" bsStyle="primary" label="global.delete" loading={false} block />
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

DeleteTaxpayerForm.propTypes = {
    isDesktop: bool.isRequired,
    fetching: bool.isRequired,
    handleClose: func.isRequired,
    openForm: bool.isRequired,
    taxpayer: shape({}).isRequired,
};

const mapStateToProps = (state) => ({
    fetching: afipPaymentLinkSelectors.getFetching(state),
});

export default connect(mapStateToProps)(DeleteTaxpayerForm);
